<template>
  <v-list>
    <template v-for="item in items">
      <v-list-tile
        :key="item.text"
        :to="item.route"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>
export default {
  data: () => ({
    items: [
      { icon: "credit_card", text: "Donations", route: "/donations" },
      { icon: "list_alt", text: "Programs", route: "/programs" },
      { icon: "room", text: "Locations", route: "/locations" },
      { icon: "trending_up", text: "Impact", route: "/impact" },
      { icon: "work", text: "Careers", route: "/careers" },
      { icon: "assignment", text: "About", route: "/about" }
      // { icon: "view_quilt", text: "Dashboard", route: "/" },
      // { icon: "contacts", text: "Volunteers", route: "/volunteers" },
      // { icon: "settings", text: "Settings", route: "/settings" },
      // { icon: "chat_bubble", text: "Message", route: "/message" }
    ]
  })
};
</script>


// WEBPACK FOOTER //
// src/components/sections-list.vue